<template>
  <div>
    <table class="table table-hover" v-if="value.length">
      <thead>
      <tr>
        <th>Name</th>
        <th>Action</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(file, index) in value" :key="index">
        <td>{{ file.name }}</td>
        <td>
          <a type="button"
             :href="url +'/form/download/file/'+field.name.split('-')[1]+'_'+file.file+'?token='+token"
             target="_blank"
             class="btn btn-xs green">
            <i class="fa fa-download" aria-hidden="true"/>
          </a>
          <button v-if="!locked"
                  type="button" class="btn btn-xs green"
                  @click.prevent="removeFile(file)"><i
            class="fa fa-trash"
            aria-hidden="true"></i></button>
        </td>
      </tr>
      </tbody>
    </table>
    <vue-upload-component
      v-show="field.multiple || value.length === 0"
      v-if="!locked"
      ref="fileUploadRef"
      :multiple="field.multiple"
      v-model="uploadedFiles"
      :input-id="'f-' + field.name"
      @input-file="inputFile"
      @input-filter="inputFilter"
    >
      <a type="button" class="btn green">Add File</a>
    </vue-upload-component>
  </div>
</template>

<script>
import { ref } from "vue";

import VueUploadComponent from 'vue-upload-component';
import {URL} from '@/http-common';

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
  },

  components: {VueUploadComponent},
  emits: ['input'],

  setup(props, { emit }) {
    const fileUploadRef = ref()
    const uploadedFiles = ref([])

    const removeFile = (file) => {
      // TODO: add support in form renderer
      emit('input', props.value.filter(f => f !== file))
    }

    const inputFile = (newFile, oldFile) => {
      if (newFile && !oldFile) {
        newFile.blob = '';

        const URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file)
        }

        emit('input', [...props.value, newFile])
      }
    }

    const inputFilter = (newFile, oldFile, prevent) => {
      if (newFile && !oldFile) {

        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }

        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }

        if (newFile.size > 64 * 1024 * 1024) {
          this.$notify({
            type: 'error',
            text: 'The uploaded file size exceeds the maximum size (64M).'
          });
          return prevent()
        }
      }
    }

    return {
      inputFile,
      inputFilter,
      removeFile,
      uploadedFiles,
      fileUploadRef,
      url: URL,
      // TODO: move this to vuex
      token: localStorage.getItem('id_token')
    }
  }
}
</script>



// WEBPACK FOOTER //
// FileRender.vue?18c7bfc7